import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Row, Col, Form, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { ro } from "date-fns/locale";

function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

function monthStartISO() {
  const d = new Date();
  d.setDate(1);
  return d.toISOString().slice(0, 10);
}

export default function Rapoarte() {
  const navigate = useNavigate();
  const [from, setFrom] = useState(monthStartISO());
  const [to, setTo] = useState(todayISO());

  const qs = useMemo(() => {
    const p = new URLSearchParams();
    p.set("from", from);
    p.set("to", to);
    return p.toString();
  }, [from, to]);

  const openPrint = (path) => window.open(`${path}?${qs}`, "_blank");

  return (
    <div className="p-3">
      <Card className="mb-3">
        <Card.Body>
          <Card.Title>Rapoarte</Card.Title>

          <Row className="g-2 align-items-end">
            {/* <Col xs={12} md={4}>
              <Form.Label>De la</Form.Label>
              <Form.Control
                type="date"
                value={from}
                onChange={(e) => setFrom(e.target.value)}
              />
            </Col>

            <Col xs={12} md={4}>
              <Form.Label>Până la</Form.Label>
              <Form.Control
                type="date"
                value={to}
                onChange={(e) => setTo(e.target.value)}
              />
            </Col> */}

            <Col xs={12} md={4}>
              <Form.Label>De la</Form.Label>

              <DatePicker
                selected={from ? new Date(from) : null}
                onChange={(date) =>
                  setFrom(date ? date.toISOString().split("T")[0] : "")
                }
                dateFormat="dd.MM.yyyy"
                locale={ro}
                className="form-control"
              />
            </Col>

            <Col xs={12} md={4}>
              <Form.Label>Până la</Form.Label>

              <DatePicker
                selected={to ? new Date(to) : null}
                onChange={(date) =>
                  setTo(date ? date.toISOString().split("T")[0] : "")
                }
                dateFormat="dd.MM.yyyy"
                locale={ro}
                className="form-control"
              />
            </Col>
            <Col xs={12} md={4} className="d-flex gap-2">
              <Button
                variant="outline-secondary"
                onClick={() => {
                  setFrom(monthStartISO());
                  setTo(todayISO());
                }}
              >
                Luna curentă
              </Button>
              <Button
                variant="outline-secondary"
                onClick={() => {
                  const d = new Date();
                  const y = d.getFullYear();
                  setFrom(`${y}-01-01`);
                  setTo(todayISO());
                }}
              >
                An curent
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Row className="g-3">
        <Col xs={12} md={6}>
          <Card className="shadow-sm border-0 rounded-4">
            <Card.Body>
              <Card.Title className="fw-bold mb-3">TVA</Card.Title>
              <div className="d-flex flex-column gap-3">
                <div>
                  <div className="fw-semibold text-secondary small mb-2">Vânzări (Ieșiri):</div>
                  <div className="d-flex flex-wrap gap-2">
                    <Button
                      variant="primary"
                      onClick={() => openPrint("/rapoarte/jurnal-tva/print")}
                      className="fw-semibold"
                    >
                      Print Jurnal TVA
                    </Button>

                    <Button
                      variant="outline-primary"
                      onClick={() => navigate(`/rapoarte/jurnal-tva?${qs}`)}
                      className="fw-semibold"
                    >
                      Vezi Jurnal TVA
                    </Button>

                    <Button
                      variant="outline-primary"
                      onClick={() => navigate(`/rapoarte/jurnal-tva-iesiri-incasare?${qs}`)}
                      className="fw-semibold"
                    >
                      Vezi Jurnal TVA vânzări (la încasare)
                    </Button>

                    <Button
                      variant="outline-primary"
                      onClick={() => navigate(`/rapoarte/jurnal-tva-iesiri-valuta?${qs}`)}
                      className="fw-semibold"
                    >
                      Vezi Jurnal TVA vânzări (în valută)
                    </Button>
                  </div>
                </div>

                <hr className="my-1 border-light-subtle" />

                <div>
                  <div className="fw-semibold text-secondary small mb-2">Cumpărări (Intrări):</div>
                  <div className="d-flex flex-wrap gap-2">
                    <Button
                      variant="outline-primary"
                      onClick={() => navigate(`/rapoarte/jurnal-tva-intrari-incasare?${qs}`)}
                      className="fw-semibold"
                    >
                      Vezi Jurnal TVA cumpărări (la încasare)
                    </Button>

                    <Button
                      variant="outline-primary"
                      onClick={() => navigate(`/rapoarte/jurnal-tva-valuta?${qs}`)}
                      className="fw-semibold"
                    >
                      Vezi Jurnal TVA cumpărări (în valută)
                    </Button>
                  </div>
                </div>
              </div>
              <div className="text-muted mt-3" style={{ fontSize: 12 }}>
                Rapoarte Jurnal TVA pe cote pentru perioada selectată.
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} md={6}>
          <Card>
            <Card.Body>
              <Card.Title>Stoc</Card.Title>
              <div className="d-flex flex-wrap gap-2">
                <Button
                  variant="outline-primary"
                  onClick={() => openPrint("/rapoarte/stoc/print")}
                  disabled
                  title="Îl facem după ce terminăm TVA"
                >
                  Print Stoc (în curând)
                </Button>
              </div>
              <div className="text-muted mt-2" style={{ fontSize: 12 }}>
                (placeholder) Raport stoc cu print.
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
